export default __webpack_public_path__ + "static/media/bezeboh.fa1d4b92.png";